import type { Shop, ShopTagInfo } from '@@partner:types:app'

import React from 'react'
import {
  formatDateObjectToTimeString,
  representTimeWithDateObject
} from '@@partner:helpers/date-utils'

import { Link, generatePath } from 'react-router-dom'
import { Button, Table, Tag } from 'rsuite'
import AppLoader from '@components/common/AppLoader'
import CommonStatusLabel from '@components/common/CommonStatusLabel'

import { ROUTE_SHOP_TAGS_EDIT, ROUTE_SHOPS_EDIT_SHOP, ROUTE_SHOPS_SLOTS } from '@@partner:config/routes'
import { SortType } from 'rsuite/esm/Table'

const Column = Table.Column
const HeaderCell = Table.HeaderCell
const Cell = Table.Cell

export interface ShopTagsTableProps {
  brandSlug: string
  shopTags: ShopTagInfo[]
  loading?: boolean
  onSortColumn?: ((dataKey: string, sortType?: SortType) => void) | undefined
  tableSort: {
    fieldName: string
    direction: number
    sortType: SortType
  }
}

export default function ShopTagsTable ({
  brandSlug,
  shopTags = [],
  loading = false,
  onSortColumn,
  tableSort
}: ShopTagsTableProps) {
  return (
    <Table
      data={shopTags}
      autoHeight
      wordWrap
      loading={loading}
      onSortColumn={onSortColumn}
      sortColumn={tableSort.fieldName}
      sortType={tableSort.sortType}
      renderLoading={() =>
        loading ? <AppLoader.Inner content="Загрузка таблицы" /> : null
      }
      affixHeader
    >
      <Column sortable flexGrow={1} verticalAlign="middle">
        <HeaderCell>ID</HeaderCell>
        <Cell dataKey="id" />
      </Column>

      <Column sortable flexGrow={2} verticalAlign="middle">
        <HeaderCell>Название</HeaderCell>
        <Cell dataKey="name" />
      </Column>

      <Column sortable flexGrow={2} verticalAlign="middle">
        <HeaderCell>Системное название</HeaderCell>
        <Cell dataKey="system_name" />
      </Column>

      <Column flexGrow={2} fixed="right" verticalAlign="middle">
        <HeaderCell>Управление</HeaderCell>
        <Cell>
          {(shopTag: ShopTagInfo) => (
            <>
              <Button
                color="cyan"
                as={Link}
                to={generatePath(ROUTE_SHOP_TAGS_EDIT, {
                  brandSlug,
                  shopTagId: shopTag.id
                })}
                size="xs"
              >
                Изменить
              </Button>
            </>
          )}
        </Cell>
      </Column>
    </Table>
  )
}
